import React from "react";
import {
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Box,
  Icon,
  Text,
} from "@chakra-ui/react";
import { MdArrowUpward, MdArrowDownward } from "react-icons/md";

export default function StatisticCard(props) {
  const { title, value, icon, iconBg, trend, trendValue } = props;
  
  // Renk değişkenleri
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");
  const boxBg = useColorModeValue("white", "navy.700");
  const iconBoxBg = useColorModeValue(iconBg || "#e45858", "#e45858"); // İkon arka plan rengi #e45858 olarak sabitlendi
  const iconColor = useColorModeValue("white", "white"); // İkon rengi her zaman beyaz
  const iconBoxShadow = useColorModeValue(
    "0px 2px 5px rgba(0, 0, 0, 0.1)",
    "0px 2px 5px rgba(255, 255, 255, 0.1)"
  );
  const trendUpColor = useColorModeValue("green.500", "green.300");
  const trendDownColor = useColorModeValue("red.500", "red.300");
  const trendNeutralColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Box py="15px" bg={boxBg} borderRadius="20px" boxShadow="sm">
      <Flex
        my="auto"
        h="100%"
        align="center"
        justify="center"
        px="20px"
      >
        <Flex
          align="center"
          justify="center"
          bg={iconBoxBg}
          h="40px" // İkon kutusu boyutu artırıldı
          w="40px" // İkon kutusu boyutu artırıldı
          borderRadius="50%"
          me="12px"
          boxShadow={iconBoxShadow}
        >
          {/* İkon boyutu artırıldı */}
          {icon && typeof icon === 'object' ? (
            React.cloneElement(icon, { 
              color: iconColor, 
              size: "20px", // İkon boyutu artırıldı
              style: { width: "20px", height: "20px" } // İkon boyutu artırıldı
            })
          ) : (
            <Icon as={icon} color={iconColor} h="20px" w="20px" /> // İkon boyutu artırıldı
          )}
        </Flex>
        <Stat my="auto">
          <StatLabel
            lineHeight="100%"
            color={textColorSecondary}
            fontSize="sm"
            fontWeight="500"
            mb="4px"
          >
            {title}
          </StatLabel>
          <Flex align="center">
            <StatNumber
              color={textColor}
              fontSize="xl"
              fontWeight="700"
              lineHeight="100%"
            >
              {value}
            </StatNumber>
            
            {trend && (
              <Flex align="center" ms="10px">
                {trend === "up" ? (
                  <Icon as={MdArrowUpward} color={trendUpColor} boxSize={4} />
                ) : trend === "down" ? (
                  <Icon as={MdArrowDownward} color={trendDownColor} boxSize={4} />
                ) : null}
                <Text 
                  fontSize="xs" 
                  fontWeight="bold" 
                  color={
                    trend === "up" 
                      ? trendUpColor 
                      : trend === "down" 
                      ? trendDownColor 
                      : trendNeutralColor
                  }
                  ml="2px"
                >
                  {trendValue}
                </Text>
              </Flex>
            )}
          </Flex>
        </Stat>
      </Flex>
    </Box>
  );
} 